// extracted by mini-css-extract-plugin
export default {"root":"styles_root__qyrFr","title":"styles_title__ZTWfX","text":"styles_text__QT+oi"};